export const tfaHasBeenEnabled =
  'Two factor authentication has been enabled for your account. Please log-in again.';
export const tfaHasBeenEnabledDownloadFile =
  'Two factor authentication has been enabled for your account. Please log-in again to access your download.';
